var _path, _path2, _path3, _path4, _path5, _pattern;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLincolnLoader({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 180",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern)",
    d: "M165.8,58.8c-2-0.1-6.3-0.4-8.5-0.6c-4.5-0.3-4.9-1.4-4.9-4.8c0-1.6-0.3-31.1-0.9-48.9 c-1.5-0.1-2.9-0.1-4.4,0c-0.7,17.8-0.9,47.4-0.9,48.9c0,3.4-0.4,4.6-4.9,4.8c-2.3,0.1-6.4,0.4-8.5,0.6c0,0.6,0,1.1,0,1.7 c0,0.6,0,1.1,0,1.7c2.3,0.2,6.3,0.4,8.5,0.6c4.5,0.3,4.9,1.4,4.9,4.8c0,1.6,0.3,31.3,0.9,48.9c1.5,0.1,2.9,0.1,4.4,0 c0.7-17.5,0.9-47.2,0.9-48.9c0-3.4,0.4-4.6,4.9-4.8c2.2-0.1,6.1-0.4,8.5-0.5c0-0.6,0-1.1,0-1.7C165.8,59.9,165.8,59.3,165.8,58.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern)",
    d: "M140.5,14.6c0.6-2.8,1.3-2.9,3.4-3.2c0.4-0.1,0.8-0.1,1.1-0.1l1-6.7c-1.5,0.1-3.1,0.3-4.8,0.6 c-3.5,0.5-3.7,0.9-4.3,4.2c-1.3,8.2-4.1,26.5-4.3,48.5l3.6-1.3C136.6,34.2,140.1,16.6,140.5,14.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern)",
    d: "M157.9,14.6c-0.6-2.8-1.3-2.9-3.4-3.2c-0.4-0.1-0.8-0.1-1.1-0.1l-1-6.7c1.5,0.1,3.1,0.3,4.8,0.6 c3.5,0.5,3.7,0.9,4.3,4.2c1.3,8.2,4.1,26.5,4.3,48.5l-3.6-1.3C161.8,34.2,158.3,16.6,157.9,14.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern)",
    d: "M140.5,106.3c0.6,2.8,1.3,2.9,3.4,3.2c0.4,0,0.8,0.1,1.1,0.1l1,6.7c-1.5-0.1-3.1-0.3-4.8-0.6 c-3.5-0.5-3.7-0.9-4.3-4.2c-1.3-8.2-4.1-26.5-4.3-48.5l3.6,1.3C136.6,86.7,140.1,104.3,140.5,106.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern)",
    d: "M157.9,106.3c-0.6,2.8-1.3,2.9-3.4,3.2c-0.4,0-0.8,0.1-1.1,0.1l-1,6.7c1.5-0.1,3.1-0.3,4.8-0.6 c3.5-0.5,3.7-0.9,4.3-4.2c1.3-8.2,4.1-26.5,4.3-48.5l-3.6,1.3C161.8,86.7,158.3,104.3,157.9,106.3"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "25%",
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "75%",
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#000000"
    }
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    x: 0,
    y: 0,
    width: "10%",
    height: "300%",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "300%",
    fill: "url(#gradient)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "y",
    from: "-100%",
    to: "100%",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "300%",
    fill: "url(#gradient)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "y",
    from: "100%",
    to: "-100%",
    dur: "3s",
    repeatCount: "indefinite"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLincolnLoader);
export default __webpack_public_path__ + "static/media/lincoln-loader.d8d3a1044c2cd1b7e73be25749873ca0.svg";
export { ForwardRef as ReactComponent };